module.exports = __webpack_public_path__ + "assets/HKNova-ExtraLight.svg";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-ExtraLight.svg
// module id = 116
// module chunks = 0